import { render, staticRenderFns } from "./subheadlineBox.vue?vue&type=template&id=46d5b150&"
import script from "./subheadlineBox.vue?vue&type=script&lang=js&"
export * from "./subheadlineBox.vue?vue&type=script&lang=js&"
import style0 from "./subheadlineBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports